import * as moment from 'moment';

import {
    AccountBalanceResponseInterface,
    CashAccountDetailedReportModel,
    CompanyExtendedModel, FundCreateOrderInterface,
    FundOpenPositionsRowInterface,
    FundOrderFilterModel,
    FundOrderReportInterface,
    FundOrderReportModel,
    FundOrdersService,
    FundOrderStatusesEnum, FundOrderTotalsInterface, FundOrderTotalsRequestInterface,
    FundOrderTypesEnum,
    FundProductInterface,
    FundProductTypesEnum,
    HttpStatusCodesEnum,
    OperatorInterface,
    ProductCategory,
    ServerResponse,
    TradingAccountDetailedReportModel,
} from '@spa/api';

import {AlertTypesEnum, ComponentTypesEnum, UnspecifiedKeysEnum} from '../../../app/shared/enums';
import {FilterControlInterface} from '../../../app/shared/interfaces';
import {
    DialogComponent,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData,
} from '../../../app/shared/components';
import {
    AmountControl,
    AutocompleteControl,
    BaseControl,
    DatepickerControl, DecimalRounding,
    Helper,
    SelectControl,
} from '../../../app/shared/classes';
import {environment} from 'appEnv/environment';
import {MatDialogRef} from "@angular/material/dialog";
import {AlertsService} from "appShared/services";
import {PanelPaths} from "appShared/paths";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";

export const PanelOrdersRequestIdSelector = 'id';
export const PanelOrdersFilterAmountSelector = 'filterAmount';
export const PanelOrdersFilterDateSelector = 'filterDate';
export const PanelOrdersStorageId = 'PanelOrdersComponent';
export const PanelOrdersFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: FundOrderFilterModel.getOrderStatusSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: FundOrderFilterModel.getOrderStatusSelector(),
                    value: FundOrderStatusesEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.All),
                            value: FundOrderStatusesEnum.All,
                        },
                        {
                            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.New),
                            value: FundOrderStatusesEnum.New,
                        },
                        {
                            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Pending),
                            value: FundOrderStatusesEnum.Pending,
                        },
                        {
                            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Matched),
                            value: FundOrderStatusesEnum.Matched,
                        },
                        {
                            label: Helper.textsHelper().getOrderStatusName(FundOrderStatusesEnum.Completed),
                            value: FundOrderStatusesEnum.Completed,
                        },
                        {
                            label: Helper.textsHelper().getOrderStatusName( FundOrderStatusesEnum.Rejected),
                            value: FundOrderStatusesEnum.Rejected,
                        },
                        {
                            label: Helper.textsHelper().getOrderStatusName( FundOrderStatusesEnum.Problematic),
                            value: FundOrderStatusesEnum.Problematic,
                        },
                    ],
                }),
            ],
            sortIndex: 1,
        },
        {
            name: FundOrderFilterModel.getOrderTypeSelector(),
            placeholder: 'Order Type',
            controls: [
                new SelectControl({
                    name: FundOrderFilterModel.getOrderTypeSelector(),
                    value: FundOrderTypesEnum.All,
                    placeholder: 'Order Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getOrderTypeName(FundOrderTypesEnum.All),
                            value: FundOrderTypesEnum.All,
                        },
                        {
                            label: Helper.textsHelper().getOrderTypeName(FundOrderTypesEnum.Buy),
                            value: FundOrderTypesEnum.Buy,
                        },
                        {
                            label: Helper.textsHelper().getOrderTypeName(FundOrderTypesEnum.Sell),
                            value: FundOrderTypesEnum.Sell,
                        },
                        {
                            label: Helper.textsHelper().getOrderTypeName(FundOrderTypesEnum.Payout),
                            value: FundOrderTypesEnum.Payout,
                        },
                    ],
                }),
            ],
            sortIndex: 2,
        },
        {
            name: FundOrderFilterModel.getProductTypeSelector(),
            placeholder: 'Product Type',
            controls: [
                new SelectControl({
                    name: FundOrderFilterModel.getProductTypeSelector(),
                    value: FundProductTypesEnum.All,
                    placeholder: 'Product Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getProductTypeName(FundProductTypesEnum.All),
                            value: FundProductTypesEnum.All,
                        },
                        {
                            label: Helper.textsHelper().getProductTypeName(FundProductTypesEnum.InvestmentCertificate),
                            value: FundProductTypesEnum.InvestmentCertificate,
                        },
                        {
                            label: Helper.textsHelper().getProductTypeName(FundProductTypesEnum.Bonds),
                            value: FundProductTypesEnum.Bonds,
                        },
                        {
                            label: Helper.textsHelper().getProductTypeName(FundProductTypesEnum.MutualFund),
                            value: FundProductTypesEnum.MutualFund,
                        },
                    ],
                }),
            ],
            sortIndex: 3,
        },
        {
            name: FundOrderFilterModel.getAccountHolderNameSelector(),
            placeholder: 'Client',
            controls: [
                new BaseControl({
                    name: FundOrderFilterModel.getAccountHolderNameSelector(),
                    value: null,
                    placeholder: 'Client',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                }),
            ],
            sortIndex: 4,
        },
        {
            name: FundOrderFilterModel.getAccountReferenceIdSelector(),
            placeholder: 'Account',
            controls: [
                new AutocompleteControl({
                    name: FundOrderFilterModel.getAccountReferenceIdSelector(),
                    value: null,
                    placeholder: 'Account',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedAccountsKey
                        }
                    ]
                })
            ],
            sortIndex: 5,
        },
        {
            name: PanelOrdersFilterAmountSelector,
            placeholder: 'Amount',
            controls: [
                new AmountControl({
                    name: FundOrderFilterModel.getAmountFromSelector(),
                    value: null,
                    placeholder: 'Amount From',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 1,
                }),
                new AmountControl({
                    name: FundOrderFilterModel.getAmountToSelector(),
                    value: null,
                    placeholder: 'Amount To',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 2,
                }),
            ],
            sortIndex: 6,
        },
        {
            name: PanelOrdersFilterDateSelector,
            placeholder: 'Created Date',
            controls: [
                new DatepickerControl({
                    name: FundOrderFilterModel.getDateFromSelector(),
                    value: null,
                    placeholder: 'Created Date From',
                    maxDate: moment().format(environment.dateFormatLocalDate),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1,
                }),
                new DatepickerControl({
                    name: FundOrderFilterModel.getDateToSelector(),
                    value: null,
                    placeholder: 'Created Date To',
                    maxDate: moment().format(environment.dateFormatLocalDate),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2,
                }),
            ],
            sortIndex: 7,
        },
        {
            name: PanelOrdersFilterDateSelector,
            placeholder: 'Settled Date',
            controls: [
                new DatepickerControl({
                    name: FundOrderFilterModel.getSettledDateFromSelector(),
                    value: null,
                    placeholder: 'Settled Date From',
                    maxDate: moment().format(environment.dateFormatLocalDate),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1,
                }),
                new DatepickerControl({
                    name: FundOrderFilterModel.getSettledDateToSelector(),
                    value: null,
                    placeholder: 'Settled Date To',
                    maxDate: moment().format(environment.dateFormatLocalDate),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2,
                }),
            ],
            sortIndex: 7,
        },
        {
            name: FundOrderFilterModel.getOrderIdSelector(),
            placeholder: 'Order ID',
            controls: [
                new BaseControl({
                    name: FundOrderFilterModel.getOrderIdSelector(),
                    value: null,
                    placeholder: 'Order ID',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                }),
            ],
            sortIndex: 8,
        },
        {
            name: FundOrderFilterModel.getCreatedByUserSelector(),
            placeholder: 'Created By',
            controls: [
                new BaseControl({
                    name: FundOrderFilterModel.getCreatedByUserSelector(),
                    value: null,
                    placeholder: 'Created By',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                }),
            ],
            sortIndex: 9,
        },
        {
            name: FundOrderFilterModel.getProductNameSelector(),
            placeholder: 'Name',
            controls: [
                new AutocompleteControl({
                    name: FundOrderFilterModel.getProductNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [
                        {
                            label: 'All',
                            value: null
                        }
                    ]
                })
            ],
            sortIndex: 10,
        },
        {
            name: FundOrderFilterModel.getProductSymbolSelector(),
            placeholder: 'Symbol',
            controls: [
                new BaseControl({
                    name: FundOrderFilterModel.getProductSymbolSelector(),
                    value: null,
                    placeholder: 'Symbol',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                }),
            ],
            sortIndex: 11,
        },
        {
            name: FundOrderFilterModel.getProductVersionSelector(),
            placeholder: 'Valor',
            controls: [
                new AutocompleteControl({
                    name: FundOrderFilterModel.getProductVersionSelector(),
                    value: null,
                    placeholder: 'Valor',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [
                        {
                            label: 'All',
                            value: null
                        }
                    ]
                })
            ],
            sortIndex: 12,
        },
        {
            name: FundOrderFilterModel.getCurrencySelector(),
            placeholder: 'Currency',
            controls: [
                new SelectControl({
                    name: FundOrderFilterModel.getCurrencySelector(),
                    value: null,
                    placeholder: 'Currency',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                }),
            ],
            sortIndex: 13,
        },
    ];
};

export const PanelOrdersDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderStatusSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getCreatedOnDateSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderIdSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getAccountHolderNameSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderTypeSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderProductNameSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderProductSymbolSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderProductVersionSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getAmountSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getOrderCurrencySelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getQuantitySelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getSettledOnDateSelector(),
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: FundOrderReportModel.getCreatedByUserSelector(),
            value: null,
            hidden: false,
        }),
    ];
};

export const PanelOrdersDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Status',
            selector: FundOrderReportModel.getOrderStatusSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Date Created',
            selector: FundOrderReportModel.getCreatedOnDateSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Order Id',
            selector: FundOrderReportModel.getOrderIdSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Client',
            selector: FundOrderReportModel.getAccountHolderNameSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Account',
            selector: FundOrderReportModel.getAccountReferenceIdSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Type',
            selector: FundOrderReportModel.getOrderTypeSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Name',
            selector: FundOrderReportModel.getOrderProductNameSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Symbol',
            selector: FundOrderReportModel.getOrderProductSymbolSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Valor',
            selector: FundOrderReportModel.getOrderProductVersionSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Amount',
            selector: FundOrderReportModel.getAmountSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Currency',
            selector: FundOrderReportModel.getOrderCurrencySelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Quantity',
            selector: FundOrderReportModel.getQuantitySelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Date Settled',
            selector: FundOrderReportModel.getSettledOnDateSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Created By',
            selector: FundOrderReportModel.getCreatedByUserSelector(),
            sortable: true
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false,
};

const FeeMinimum = 0.5;
const FeeMultiplier = 0.0015;

export abstract class FundCreateOrderComponent<T> extends DialogComponent<T> {
    protected readonly orderSubscriptions: Subscription[];

    public model: CreateOrderModel;
    public orderType: FundOrderTypesEnum;
    public loading: boolean;
    public dateFormat = 'dd.MM.yyyy';

    protected constructor(
        public account: TradingAccountDetailedReportModel | CashAccountDetailedReportModel,
        public operator: OperatorInterface,
        public readonly ordersService: FundOrdersService,
        public readonly alertsService: AlertsService,
        public readonly router: Router,
        public dialogRef: MatDialogRef<T>) {
        super(dialogRef);


        this.orderSubscriptions = [];
        const model = new CreateOrderModel();

        model.isFourDecimals = false;
        model.isInteger = false;
        model.account = this.account;

        model.totals = {
            amount: 0,
            cleanPrice: 0,
            fee: 0,
            price: 0,
            quantity: 0,
            interest: 0,
            warning: false,
            insufficient: false,
        }

        this.model = model;
    }

    get isBuy(): boolean {
        return this.orderType === FundOrderTypesEnum.Buy;
    }

    get isSell(): boolean {
        return this.orderType === FundOrderTypesEnum.Sell;
    }

    get isBonds(): boolean {
        return this.model.product.type === FundProductTypesEnum.Bonds;
    }

    get isMutualFunds(): boolean {
        return this.model.product.type === FundProductTypesEnum.MutualFund;
    }

    get isCouponBonds(): boolean {
        return [ProductCategory.FixedRateBonds, ProductCategory.FloatingRateBonds].indexOf(this.model.product.category) >= 0;
    }

    private initInput(): void {
        this.model.isInteger = false;
        this.model.isFourDecimals = false;

        if (this.isSell) {
            switch (this.model.product.type) {
                case FundProductTypesEnum.Bonds:
                    this.model.isFourDecimals = true;
                    break;
                case FundProductTypesEnum.MutualFund:
                    this.model.isFourDecimals = true;
                    break;
                default:
                    this.model.isFourDecimals = true;
                    break;
            }
        } else {
            switch (this.model.product.type) {
                case FundProductTypesEnum.Bonds:
                    this.model.isInteger = true;
                    break;
                case FundProductTypesEnum.MutualFund:
                    this.model.isFourDecimals = false;
                    break;
                default:
                    this.model.isInteger = true;
                    break;
            }
        }
    }

    abstract getPrice(): number;
    abstract getInterest(): number;

    protected getOrderTotalsRequest(): FundOrderTotalsRequestInterface {
        const request: FundOrderTotalsRequestInterface = {
            inputValue: this.model.inputValue,
            method: OrderCalculationMethod.Default,
            orderType: this.orderType,
            productSymbol: this.model.product.code
        };

        return request;
    }

    protected calculateBe(): void {
        const request = this.getOrderTotalsRequest();

        const subscription = this.ordersService.calculateOrderTotals(request)
            .subscribe(response => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    this.alertsService.addAlert('Cannot calculate order totals.');
                    return;
                }

                const totals = response.data as FundOrderTotalsInterface;

                Object.assign(this.model.totals, totals);

                this.validate();
            });

        this.orderSubscriptions.push(subscription);
    }

    protected validate(): void {
        if (this.orderType === FundOrderTypesEnum.Buy) {
            this.validateBuy();
        } else {
            this.validateSell();
        }
    }

    private validateSell(): void {
        this.model.totals.insufficient = false;
        this.model.totals.warning = false;

        if (!this.model.position) {
            this.model.totals.insufficient = true;
            this.alertsService.addAlert('Failed to get open position.');
            this.dialogRef.close(false);

            return;
        }

        if (this.model.position.availableProductQuantity <= 0) {
            this.model.totals.insufficient = true;
        }

        switch (this.model.product.type) {
            case FundProductTypesEnum.MutualFund:
            case FundProductTypesEnum.InvestmentCertificate:
                if (this.model.totals.quantity > this.model.position.availableProductQuantity) {
                    this.model.totals.insufficient = true;
                }
                break;
            case FundProductTypesEnum.Bonds:
                const availableFaceValueOwned = DecimalRounding.round((this.model.position.quantity * this.model.product.nominalValue), 4);
                if (this.model.inputValue > availableFaceValueOwned) {
                    this.model.totals.insufficient = true;
                }

                if (this.model.totals.amount < this.model.product.minimumBuyOrderSize) {
                    this.model.totals.warning = true;
                }
                break;
        }
    }
    private validateBuy(): void {
        const cash = this.model.cash?.balance || 0;

        this.model.totals.warning = false;

        if (cash === 0) {
            this.model.totals.insufficient = true;
        }

        switch (this.model.product.type) {
            case FundProductTypesEnum.All:
                break;
            case FundProductTypesEnum.MutualFund:
                if (this.model.totals.amount < this.model.product.minimumBuyOrderSize) {
                    this.model.totals.warning = true;
                }

                break;
            case FundProductTypesEnum.Bonds:
                if (this.model.inputValue % this.model.product.minimumBuyOrderSize !== 0) {
                    this.model.totals.warning = true;
                }

                break;
        }

        this.model.totals.insufficient = this.model.totals.amount + this.model.totals.fee > cash
    }

    init(product: FundProductInterface,
         position: FundOpenPositionsRowInterface,
         cash: AccountBalanceResponseInterface): void {
        this.model.product = product;
        this.model.cash = cash;
        this.model.position = position;

        this.initInput()
    }

    onValueChanged(amount: string | null): void {
        if (amount) {
            this.model.inputValue = +Helper.compactString(amount);
        } else {
            this.model.inputValue = 0;
        }

        if (this.model.product) {
            this.calculateBe();
        }
    }

    getRequestModel(): FundCreateOrderInterface {
        const tradingAccount = this.account as TradingAccountDetailedReportModel;
        const totalsRequest = this.getOrderTotalsRequest();

        return {
            ...totalsRequest,
            orderType: this.orderType,
            orderPlacementMethod: 1,
            productSymbol: this.model.product.code,
            productType: this.model.product.type,
            currency: this.model.product.currency,
            accountHolderId: this.account.ownerId,
            accountHolderName: this.account.ownerName,
            accountHolderIsCompany: this.model.account.isOwnerCompany,
            accountId: tradingAccount.cashAccountId,
            accountReferenceId: tradingAccount.cashAccountReferenceId,
            createdByUserId: this.operator.user_id,
            createdByUser: this.operator.email,
            portalBuildNumber: 'CRM'
        };
    }

    getFee(amount: number): number {
        const calculatedFee = amount * FeeMultiplier;

        const fee = calculatedFee >= FeeMinimum
            ? calculatedFee
            : FeeMinimum;

        return fee;
    }

    confirmOrderMethod(): ServerResponse<FundOrderReportInterface> {
        const requestModel = this.getRequestModel();

        return this.ordersService.createOrder(requestModel);
    }

    confirmOrder(): void {
        if (this.model.invalid) {
            this.alertsService.addAlert('The values are invalid');
        } else {
            const method = this.confirmOrderMethod();

            if (!method) {
                return;
            }

            this.loading = true;

            method.subscribe(response => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    this.alertsService.addAlert('Failed to create order');

                    this.dialogRef.close(false);
                } else {
                    this.alertsService.addAlert('Order created', AlertTypesEnum.Success);

                    const order = response.data as FundOrderReportInterface;
                    const redirectUrl = [
                        PanelPaths.root,
                        PanelPaths.children.orders.path,
                        PanelPaths.children.orders.children.edit.path,
                        order.orderId
                    ].join('/');

                    this.router.navigateByUrl(redirectUrl).finally();

                    this.dialogRef.close(true);
                }
            });
        }
    }
}

export class CreateOrderModel {
    inputValue: number = 0;
    account: TradingAccountDetailedReportModel | CashAccountDetailedReportModel;
    company: CompanyExtendedModel;
    isFourDecimals: boolean;
    isInteger: boolean;
    totals?: OrderTotals;
    cash?: AccountBalanceResponseInterface;
    product: FundProductInterface;
    position?: FundOpenPositionsRowInterface;

    get totalNominalValueOwned(): number {
        return this.position
            ? this.position.availableProductQuantity * this.product.nominalValue
            : 0;
    }

    get totalNominalValue(): number {
        return this.totals
            ? this.totals.quantity * this.product.nominalValue
            : 0;
    }

    get invalid(): boolean {
        return this.inputValue <= 0 || !this.totals || this.totals.insufficient || this.totals.warning;
    }
}

export interface OrderTotals extends FundOrderTotalsInterface {
    warning: boolean;
    insufficient: boolean;
}

export enum OrderViewMode {
    Input,
    Declaration,
    Review
}

export enum OrderCalculationMethod {
    Default,
    Sum = 1
}
